<div class="p-fluid p-formgrid grid">
  <div class="field col-12">
    <label htmlFor="name">Title</label>
    <input pInputText id="title" type="text" [(ngModel)]="value.Title" />
  </div>
  <div class="field col-4">
    <label htmlFor="menus">Menu(s)</label>
    <p-listbox [options]="menus" [(ngModel)]="value.MenuIds" optionLabel="Name" optionValue="Id" [multiple]="true"
      (onChange)="changed();filterMenuItems()" [checkbox]="true"></p-listbox>
  </div>

  <div class="field col-4">
    <label htmlFor="items">Menu Item(s)</label>
    <p-listbox [options]="filteredItems" [(ngModel)]="value.MenuItemIds" [multiple]="true" optionLabel="Name"
      optionValue="Id" (onChange)="changed();filterMenuOptions()" [checkbox]="true"></p-listbox>
  </div>

  <div class="field col-4">
    <label htmlFor="quantity">Menu Option(s)</label>
    <p-listbox [options]="filteredOptions" [(ngModel)]="value.MenuOptionIds" [multiple]="true" optionLabel="Name"
      optionValue="Id" (onChange)="changed()" [checkbox]="true"></p-listbox>
  </div>

  <div class="field col-12">
    <label htmlFor="quantity">Quantity</label>
    <input pInputText id="quantity" type="number" [(ngModel)]="value.Quantity" />
  </div>
</div>